import { concatLowerCase } from '@Utils/String';

// eslint-disable-next-line import/prefer-default-export
export function contextFromMetadata(metadata = {}) {
  return metadata.isViewPreview ? `${concatLowerCase(metadata.title || metadata.context)}` : metadata.context;
}
